import Block from '../block'

export default class DetailNav extends Block {
	static title = 'detail-nav'

	constructor($el) {
		super($el)

		this.dropdown = this.$el.findElement('palette-dropdown')
		this.form = this.$el.findElement('palette-form')
		this.open = this.$el.findElement('palette-open')
		this.close = this.$el.findElement('palette-dropdown-close')
		this.activePaletteName = this.$el.findElement('active-palette-name')

		this.open.on('click', () => this.openSelector())

		this.close.on('click', () => this.closeSelector())

		this.form
			.find(':input')
			.not('[data-form-manual-control]')
			.change(() => {
				this.form.submit()
			})

		this.form.on('submit', (e) => {
			e.preventDefault()

			const selectedPalette = this.form.find('input:checked')
			const palette = selectedPalette.val()

			this.activePaletteName.text(selectedPalette.data('paletteTitle'))

			const colorsDiv = selectedPalette
				.siblings('.detail-nav__palette')
				.find('.detail-nav__palette-color')

			colorsDiv.each((index, el) => {
				const colorName = $(el).data('colorName')
				const color = $('.detail-nav__color-' + colorName)

				color.css('background', $(el).css('background'))
			})

			$('input[name="palette_id"]').val(selectedPalette.data('id'))

			this.closeSelector()

			$(document).trigger('palette:change', palette)
		})
	}

	openSelector() {
		this.dropdown.removeClass('hidden')
	}

	closeSelector() {
		this.dropdown.addClass('hidden')
	}
}
